module.exports = __webpack_public_path__ + "media/img/paperplane-63a20b2d2f5d7d27565c8e357c29b8eb.png";